import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountVisibility from "./AbstractAccountVisibility.js";

/**
 * Setting to always hide all account rows in a report.
 */
class HideAccountsVisibility extends AbstractAccountVisibility {
	isVisible(row) {
		if (row.isAccountRow()) {
			return false;
		}

		return row.hasData();
	}

	showsSomeAccounts() {
		return false;
	}

	static getLabel() {
		return _("None");
	}
}

export default HideAccountsVisibility;
